import ReValidate from './../re-validation'
import props from './../../../../props/inputs'

const validationAttrs = [
  'validations',
  'validator',
  'groupClass',
  'groupErrorClass',
  'errorClass',
  'tabindex',
  'customErrors',
  'vRoot',
  'v'
]

export default {
  name: 're-input',
  components: {[ReValidate.name]: ReValidate},
  props,
  data() {
    return {
      innerValue: this.value
    }
  },
  computed: {
    validationAttrs() {
      return {
        ..._.pick(this.$props, validationAttrs),
        value: this.innerValue,
        tabindex: null
      }
    }
  },
  methods: {
    onInput(event) {
      const value = this.innerValue = event.target.value
      this.$emit('input', value)
    },
  },
}
